<template>
  <gd-login :callback="callback" class="bg-dark"></gd-login>
</template>

<script>
import Form from 'vform';
import axios from 'axios';
import GdLogin from '@groovepages/gd-ui-kit/components/Login';
import store from '@/state';
import VueCookies from 'vue-cookies';

export default {
  layout: 'basic',
  data() {
    return {
      callback: (user) => {
        if (!user.auth_keycloak) {
          axios.defaults.headers.common = {
            ...axios.defaults.headers.common,
            'x-auth-provider': 'auth0',
          };
        }
        const self = this;
        store.commit('login', user);
        self.$router.push({ name: 'dashboard' });
      },
    };
  },
  components: {
    GdLogin,
  },
};
</script>
